// Unpublished Work © 2023-2024 Deere & Company.

function setInArray(item) {
    return [].concat(item);
}

export {
    setInArray
};
